import styled from 'styled-components';
import React, { useEffect, useState } from 'react';
import CryptoJS from "crypto-js";
import { caminhoDoLogo } from '../utils/caminhosConta';

// Tela de conclusão pro fluxo de Recrutamento e Seleção. Existe separada da
// FinishContainer (compliance/denúncia) porque essa última lê o doc da
// entrevista no path legado (`cliente/{company}/...`) e mostra copy de
// evidência/feedback de denúncia — nenhum dos dois faz sentido pra um
// candidato. Antes dessa tela existir, `showFinishContainer && !isRecruitmentFlowCurrent`
// em App.js deixava o candidato numa tela em branco ao concluir a entrevista.
export default function RecruitmentFinishContainer() {
  const [logoCompanyUrl, setLogoCompanyUrl] = useState('');

  useEffect(() => {
    const resolveCompanyPath = () => {
      const pathParts = (window.location.pathname || '').split('/').filter(Boolean);
      return pathParts[0] || 'materdei';
    };

    const buildStorageLogoUrl = (bucket) => {
      if (!bucket) return '';
      const companyPath = resolveCompanyPath();
      const objectPath = caminhoDoLogo(companyPath);
      if (bucket.endsWith('firebasestorage.app')) {
        return `https://firebasestorage.googleapis.com/v0/b/${bucket}/o/${encodeURIComponent(objectPath)}?alt=media`;
      }
      return `https://storage.googleapis.com/${bucket}/${objectPath}`;
    };

    let cancelled = false;
    const params = new URLSearchParams(window.location.search);
    const encryptedData = params.get("data");
    if (encryptedData) {
      try {
        const secretKey = "due-prd";
        const decodedData = decodeURIComponent(encryptedData);
        const decryptedBase64 = CryptoJS.AES.decrypt(decodedData, secretKey).toString(CryptoJS.enc.Utf8);
        const decryptedString = atob(decryptedBase64);
        const decryptedParams = JSON.parse(decryptedString);

        const logoUrl = decryptedParams.logoCompanyUrl;
        if (logoUrl) {
          setLogoCompanyUrl(logoUrl);
          return;
        }
      } catch (e) {
        console.error("Erro ao decodificar os parâmetros da URL", e);
      }
    }

    const fetchLogoUrl = async () => {
      const bucket = process.env.REACT_APP_STORAGE_BUCKET;
      const publicUrl = bucket ? buildStorageLogoUrl(bucket) : '';
      if (!cancelled && publicUrl) {
        setLogoCompanyUrl(publicUrl);
      }
    };

    fetchLogoUrl();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <EndContainer>
      {logoCompanyUrl && (
        <img src={logoCompanyUrl} alt="Logo da empresa" onError={() => setLogoCompanyUrl('')} />
      )}
      <h1>Entrevista concluída!</h1>
      <p>Obrigado por participar do processo seletivo. Suas respostas foram registradas com sucesso.</p>
      <p>Nossa equipe de RH vai analisar sua candidatura e entrar em contato pelos canais informados no cadastro.</p>
    </EndContainer>
  );
}

const EndContainer = styled.div`
  height: 100vh;
  width: 100vw;
  background-color: #F8F9FB;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 25px;
  img {
    width: 200px;
    height: 200px;
    object-fit: contain;
    margin-bottom: 12px;
  }
  h1 {
    font-size: 38px;
    color: #333;
    font-family: "Poppins", sans-serif;
  }
  p {
    font-size: 20px;
    color: #666;
    font-family: "Poppins", sans-serif;
    margin-top: 10px;
    max-width: 560px;
  }
`;
